import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { statesData } from './us-states';
import { FeatureCollection, Feature, Polygon, MultiPolygon } from 'geojson';
import { DataserviceService } from '../dataservice.service';
interface StateInfo {
  name: string;
  providers: string[];
  color: string;
}

@Component({
  selector: 'app-map-coverage',
  templateUrl: './map-coverage.component.html',
  styleUrls: ['./map-coverage.component.css']
})
export class MapCoverageComponent implements OnInit {
  private map!: L.Map;
  states!: StateInfo[];
  filteredStatesData!: FeatureCollection;

  constructor(private dataService: DataserviceService) {
  }

  ngOnInit() {
    this.fetchStates();
  }

  private fetchStates(): void {
    this.dataService.getData('coverage').subscribe(
      (data: StateInfo[]) => {
        this.states = data;
        this.filteredStatesData = this.filterStatesData();
        this.initMap();
      },
      (error) => {
        console.error('Error fetching coverage data:', error);
        // this.message.error('Error fetching coverage data:', error);
      }
    );
  }

  private filterStatesData(): FeatureCollection {
    return {
      type: "FeatureCollection",
      features: statesData.features.filter(feature => 
        this.states.some(state => state.name === feature.properties.name)
      )
    };
  }

  private initMap(): void {
    this.map = L.map('map').setView([39.8283, -98.5795], 4);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    this.addGeoJson();
  }

  private addGeoJson(): void {
    L.geoJSON(this.filteredStatesData, {
      style: (feature) => this.style(feature),
      onEachFeature: this.onEachFeature.bind(this)
    }).addTo(this.map);
  }

  private style(feature: any): L.PathOptions {
    const stateInfo = this.states.find(state => state.name === feature.properties.name);
    return {
      fillColor: stateInfo ? stateInfo.color : '#FFEDA0',
      weight: 2,
      opacity: 1,
      color: 'white',
      dashArray: '3',
      fillOpacity: 0.7
    };
  }

  private highlightFeature(e: L.LeafletMouseEvent): void {
    const layer = e.target;

    layer.setStyle({
      weight: 5,
      color: '#666',
      dashArray: '',
      fillOpacity: 0.7
    });

    layer.bringToFront();
  }

  private resetHighlight(e: L.LeafletMouseEvent): void {
    const geojson = L.geoJSON(this.filteredStatesData, { 
      style: (feature) => this.style(feature)
    });
    geojson.resetStyle(e.target);
  }

  private zoomToFeature(e: L.LeafletMouseEvent): void {
    if (this.map) {
      this.map.fitBounds(e.target.getBounds());
    }
  }

  private onEachFeature(feature: any, layer: L.Layer): void {
    layer.on({
      mouseover: (e: L.LeafletMouseEvent) => this.highlightFeature(e),
      mouseout: (e: L.LeafletMouseEvent) => this.resetHighlight(e),
      click: (e: L.LeafletMouseEvent) => this.zoomToFeature(e)
    });

    const stateInfo = this.states.find(state => state.name === feature.properties.name);
    if (stateInfo) {
      layer.bindPopup(`
        <b>${stateInfo.name}</b><br>
        Providers: ${stateInfo.providers.join(', ')}
      `);
    }
  }
}
